import React, { Component } from 'react'
import { Row, Col, Alert, Button, Input, DatePicker, Select, Table, Icon, Popconfirm } from 'antd'
import DocTypesModel from '../models/DocTypesModel'
import DocsModel from '../models/DocsModel'
import AuthModel from '../models/AuthModel'
import Permissions from '../models/Permissions'
import DocsUpload from './DocsUpload'
import moment from 'moment'

const { TextArea } = Input
const Option = Select.Option
const dateFormat = 'YYYY/MM/DD'

class AdminDocsForm extends Component {

    constructor(props) {
        super(props)
        this.updateForm = this.updateForm.bind(this)
        this.state = Object.assign({types: [], uploads: []}, this.props.data)
    }

    loadOptions() {
        this.loading()
        DocTypesModel.findAll((items) => {
            this.setState({
                ...this.state,
                types: items
            });
        })
    }

    componentDidMount() {
        this.loadOptions()
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps.data)
    }

    updateForm(field, value) {
        const formData = this.state
        formData[field] = value
        this.setState(formData)
    }

    loading() {
        var state = Object.assign({}, this.state)
        state.loading = true
        this.setState(state)
    }

    onRemoveUpload(filename) {
        var attach = false
        this.state.uploads.forEach((item) => {
            if (filename === item.name) attach = item
        })
        this.props.removeUpload(attach)
        const formData = Object.assign({}, this.state)
        formData.uploads = formData.uploads.filter((item) => {
            return filename === item.name ? false : true
        })
        this.setState(formData)
    }

    onUploadSuccess(item) {
        const formData = Object.assign({}, this.state)
        formData.uploads.push(item)
        this.setState(formData)
    }

    downloadAttach(record) {
        var attachBaseUrl = DocsModel.endpoint() + '/download'
        var url = attachBaseUrl+'/'+record.filename+'?token=' + AuthModel.getAuthToken() + '&id='+record.id
        DocsModel.download(record.descricao, url, record.mime)
    }

    onRemoveAttach(item) {
        this.props.removeFile(item)
        const formData = Object.assign({}, this.state)
        formData.filename = '';
        formData.mime = '';
        this.setState(formData)
    }

    render() {
        const columns = [
            {
                title: 'Nome do Ficheiro',
                dataIndex: 'filename',
                key: 'filename'
            },
            {
                title: 'Opções',
                key: 'action',
                render: (text, record) => (
                    <div>
                      <a role="button" onClick={(e) => this.downloadAttach(record)}>
                          <Icon type="download" style={{color: 'green'}} />
                      </a>
                      {' '}
                      { !Permissions.isDenied('docs', 'update') ? (
                        <Popconfirm title="DESTRUIR? Não poderá voltar atrás."
                            onConfirm={(e) => this.onRemoveAttach(record)}
                            okText="Sim" cancelText="Não">
                            <a role="button">
                                <Icon type="delete" style={{color: 'red'}} />
                            </a>
                        </Popconfirm>
                    ) : '' }
                    </div>
                )
            }
        ];
        var attachments = []
        if (this.state.filename) attachments.push({
            key: this.state.id, 
            id: this.state.id,
            filename: this.state.filename,
            mime: this.state.mime
        })
        
        return (
            <Row>
                <Col span={24}>
                    <form method="post" onSubmit={(e) => {
                        e.preventDefault()
                        this.props.storeForm(this.state)
                    }}>
                        <input type="hidden" ref="id" value={this.state.id} />

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <legend>{this.state.id ? 'Alterar Documento' : 'Criar Novo Documento'}</legend>
                            </Col>
                        </Row>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="title" className="ant-form-item-required" title="Título">
                                    Título
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <input id="title"
                                    type="text"
                                    required="required"
                                    className="ant-input"
                                    value={this.state.title}
                                    ref="title"
                                    onChange={(e) => this.updateForm('title', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="description" className="ant-form-item" title="Descrição">
                                    Descrição
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <div className="ant-form-item-control ">
                                    <TextArea id="description" rows={6} value={this.state.description}
                                        onChange={(e) => this.updateForm('description', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="issuedate" className="ant-form-item-required" title="Data">
                                    Data do Documento
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <DatePicker value={moment(this.state.data, dateFormat)} format={dateFormat}
                                    onChange={(date, dateStr) => {this.updateForm('data', dateStr)}}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="type_id" className="ant-form-item-required" title="Tipo de Documento">
                                    Tipo de Documento
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <Select value={''+this.state.type_id}
                                    showSearch
                                    placeholder="Atribua um tipo"
                                    optionFilterProp="children"
                                    onChange={(v) => this.updateForm('type_id', v)}>
                                    { this.state.types.map((item) => (
                                        <Option key={''+item.id} value={''+item.id}>{item.label}</Option>
                                    ) )}
                                </Select>
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="filename" className="ant-form-item-required" title="Ficheiro">
                                    Novo Ficheiro
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <DocsUpload
                                    onRemoveUpload={this.onRemoveUpload.bind(this)}
                                    onUploadSuccess={this.onUploadSuccess.bind(this)}
                                />
                                <hr />
                                <div id="attachments">
                                    <legend>Ficheiro Atual</legend>
                                    <Table dataSource={attachments} columns={columns} />
                                </div>
                            </div>
                        </div>

                        

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <Alert className={this.props.complete && this.props.error ? '' : 'hidden'}
                                    message="Erro"
                                    description={this.props.error}
                                    type="error"
                                    showIcon
                                />
                                <Alert className={this.props.complete && !this.props.error ? '' : 'hidden'}
                                    message="Sucesso!"
                                    description="O documento foi guardado com sucesso."
                                    type="success"
                                    showIcon
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                    <button type="submit" className="ant-btn ant-btn-primary" style={{float: 'right'}}>
                                        <i className="anticon anticon-save"></i>
                                        <span>Guardar</span>
                                    </button>
                                    <Button type="danger" onClick={(e) => this.props.history.push('/docs')}>
                                        Cancelar
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                    </form>
                </Col>
            </Row>
        )
    }
}

export default AdminDocsForm;



// WEBPACK FOOTER //
// ./src/components/AdminDocsForm.js